exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.prescriptionRow .subtitle {\n  font-weight: 500;\n  margin: 0;\n}\n.prescriptionRow .subtitle p {\n  margin: 0;\n}\n.prescriptionRow div {\n  margin: 7px 0;\n}\n.prescriptionRow b {\n  font-weight: 500;\n}\n.prescriptionRow span.title {\n  font-weight: 400;\n  font-size: 13px;\n  color: #78849e;\n}\n", ""]);

// exports
